export default __webpack_public_path__ + "download-icon-arrow.svg";